import { memo, type JSX } from 'react';

import styled from '@mint-lib/styled';

import { Tooltip } from '@myn/mui';

type Props<T> = {
  icon: JSX.Element;
  value: T;
  className?: string;
  isNewData?: boolean;
  children?: JSX.Element;
  tooltip?: string;
};

function DrawerTab<T>({
  icon,
  className,
  isNewData = false,
  children,
  tooltip,
}: Props<T>) {
  return (
    <Tooltip title={tooltip} placement="left">
      <Wrapper className={className}>
        {children}
        {icon}
        <Icon isNewData={isNewData} />
      </Wrapper>
    </Tooltip>
  );
}

const Wrapper = styled('div')`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
`;

// TODO: replace with Badge component
const Icon = styled('div')<{ isNewData: boolean }>`
  display: ${({ isNewData }) => (isNewData ? 'block' : 'none')};

  position: absolute;
  top: 0;
  right: 0;

  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${'#FF566A'};
`;
export default memo(DrawerTab) as typeof DrawerTab;
